'use client';

import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { Button } from '../ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import type { SectionProps } from './custom-homepage';
import { Statistics } from '@eliadmin/core/src/components/homepage/statistics';

export function About({
  items,
  title,
  subtitle,
  description,
}: { items: TDynamicData[] } & Partial<SectionProps>) {
  const { t } = useTranslations();

  const isDesktop = useBreakpoint('sm');

  return (
    <section
      className={cn(
        'custom-section',
        'pb-16 pt-8 sm:pb-20 sm:pt-10 lg:pb-24 lg:pt-12',
        'generic-gap',
      )}
    >
      {title && <Heading center subtitle={subtitle} title={title} />}
      <Paragraph className="w-full max-w-[1058px] text-center" size="xl" innerHtml={description} />
      <Statistics stats={items} />
      <Button asChild variant={'secondary'} className="w-full sm:w-fit">
        <Link href={ROUTES.ABOUT()}>{t('text1242')}</Link>
      </Button>
    </section>
  );
}
